import { IWeek } from '../types';
import { getWeekByDate } from './getWeekByDate';
import { TimeHelper } from '../../../utils';

export function getWeeksToPrepend(weeks: IWeek[], count: number, timezone: string): IWeek[] {
  if (weeks.length === 0) return [];

  const firstWeek = weeks[0];
  const startOfPreviousWeek = TimeHelper.subtractWeeks(firstWeek.startDate, 1, timezone);
  const result: IWeek[] = [];

  for (let weeksOffset = 0; weeksOffset < count; weeksOffset += 1) {
    const startOfWeek = TimeHelper.subtractWeeks(startOfPreviousWeek, weeksOffset, timezone);
    const week = getWeekByDate(startOfWeek, timezone);
    result.unshift(week);
  }

  return result;
}
